import { Injectable, inject } from '@angular/core';
import { Menus } from '@rocksoft/cdk';
import { appMenus, environment } from '@rocksoft/environment';
import { AuthorizationService, Permissions } from '@rocksoft/shared/authorization';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MenuVisibilityService {
  private readonly authorizationService = inject(AuthorizationService);

  // This is a first implementation. We should decide how we can improve this.
  getMenus(): Menus {
    const canReadMdmSettings = this.authorizationService.getIsAuthorized$(Permissions.MdmSettingsRead);
    const isSecurityEnabled = environment.features?.security?.enabled;
    const isManagementEnabled = environment.features?.management?.enabled;
    const isDepEnabled = environment.features?.gateway?.enabled && environment.features?.dep?.enabled;

    const isAdmin$: Observable<boolean> = this.authorizationService.getIsAuthorized$(Permissions.Admin);

    return appMenus.map((menu) => {
      if (menu.routerLink === 'security') {
        menu.hidden = isAdmin$.pipe(map((isAdmin) => !(isSecurityEnabled && isAdmin)));
      } else if (menu.routerLink === 'management') {
        menu.hidden = isAdmin$.pipe(map((isAdmin) => !(isManagementEnabled && isAdmin)));
      } else if (menu.routerLink === 'mdm' && menu.children) {
        for (const child of menu.children) {
          if (child.routerLink === 'settings') {
            child.hidden = canReadMdmSettings.pipe(map((isAuthorized) => !isAuthorized));
          }

          if (child.routerLink === 'dep') {
            child.hidden = of(!isDepEnabled);
          }
        }
        menu.hidden = of(false);
      } else if (menu.routerLink === 'settings') {
        for (const child of menu.children ?? []) {
          if (child.routerLink === 'mdm') {
            child.hidden = canReadMdmSettings.pipe(map((isAuthorized) => !isAuthorized));
            break;
          }
        }

        menu.hidden = of(false);
      } else {
        menu.hidden = of(false);
      }

      return menu;
    });
  }
}
